export const SET_USER_DETAILS = 'USER.SET_DETAILS'
export const RESET_USER_DETAILS = 'USER.RESET_DETAILS'
export const SET_USER_ELIGIBILITY = 'USER.SET_ELIGIBILITY'
export const SET_USER_EXISTS = 'USER.SET_EXISTS'
